export const handleServiceResponse = (response) => {
    return response.data
}

export const handleServiceError = (error) => {
    return Promise.reject(error)
}
